export const getImageInfo = async (url, options = {}) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    Object.keys(options).forEach(key => {
      image[key] = options[key];
    });
    image.onload = () => {
      const { width, height } = image;
      resolve({ width, height, ratio: width / height, image });
    };
    image.onerror = reject;
    image.src = url;
  });

export default {};
